import * as _ from 'lodash';
import {SOUNDS as TELEKINETIC_SOUNDS} from '../Modes/Telekinetic/sounds'
import { getRandomInArray } from '../../helper';

export const HasKeymap = superclass => class extends superclass {
  constructor({ initializeKeymap, ...args }) {
    super({ ...args });
    this.entityTypes = this.entityTypes.concat('HAS_KEYMAP');
    this.keymapStack = [];
    this.initializeKeymap = initializeKeymap;
    const keymap = initializeKeymap(this.game.engine, this);
    this.addKeymap(keymap);
  }

  getKeymap () {
    return _.get(this.keymapStack, '0', null);
  }

  addKeymap (newKeymap) {
    this.keymapStack.unshift(newKeymap);
  }

  removeKeymap () {
    this.keymapStack.shift();
  }

  reinitializeKeymap (ignoredKeys = []) {
    this.keymapStack = [];
    const keymap = this.initializeKeymap(this.game.engine, this);
    ignoredKeys.forEach((key) => delete keymap[key])
    this.addKeymap(keymap);
  }

  addKeymapActionToBaseKeymap (key, keymapAction) {
    // get last in stack which is base keymap
    const baseKeymap = this.keymapStack.at(-1)
    
    const newInitialize = (engine, actor) => {
      // const base = baseKeymap(engine, actor)
      return {
        // ...base,
        ...baseKeymap,
        [key]: keymapAction
      }
    }

    this.initializeKeymap = newInitialize
    this.reinitializeKeymap()
  }

  setKeymap (newKeymap) {
    this.addKeymap(newKeymap);
    this.playSetKeymapSound();
    return this.getKeymap;
  }

  goToPreviousKeymap () {
    if (this.keymapStack.length > 1) this.removeKeymap();
    return this.getKeymap();
  }

  popToTopKeymap () {
    this.keymapStack.forEach((layer, index) => {
      if (this.keymapStack.length > 1) this.removeKeymap()
    })

    return this.getKeymap()
  }

  playSetKeymapSound() {
    getRandomInArray([
      TELEKINETIC_SOUNDS.menu_01,
      TELEKINETIC_SOUNDS.menu_04,
    ]).play()
  }
};
